import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {ParametrageFacturationHierarchy} from "../../../../core/models/facturation/client/parametrage-facturation-hierarchy";
import {NamedItem} from "../../../../core/models/named-item";
import {FacturationClientService} from "../../../../core/services/entities/facturation-client.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {ParametersGenerationLignesParametrage} from "../../../../core/models/facturation/client/parameters-generation-lignes-parametrage";
import {LigneParametrageFacturation} from "../../../../core/models/facturation/client/ligne-parametrage-facturation";
import {TypeFactureClientEnum} from "../../../../core/enums/facturation/client/type-facture-client-enum";
import { ButtonThemeEnum } from '../../../../shared/ui/button/button-theme-enum';


@Component({
  selector: 'yo-adding-area-ligne-parametrage',
  templateUrl: './adding-area-ligne-parametrage.component.html',
  styleUrls: ['./adding-area-ligne-parametrage.component.scss'],
  standalone: false
})
export class AddingAreaLigneParametrageComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Input() selectedTypeFactureClient: TypeFactureClientEnum;
  @Output() onNewLigneParametrage: EventEmitter<LigneParametrageFacturation[]> = new EventEmitter();

  subHierarchy: Subscription;
  subToAdd: Subscription;

  // region Propriétés ajout de lignes de paramétrage

  public isAddAreaCollapsed: boolean = true;

  public cellTypes = AddZoneProperty;

  public hierarchy: ParametrageFacturationHierarchy;

  public offreAlimentaireList: NamedItem[] = [];
  public prestationList: NamedItem[] = [];
  public repasList: NamedItem[] = [];
  public regimeList: NamedItem[] = [];
  public pointFacturationList: NamedItem[] = [];
  public pointLivraisonList: NamedItem[] = [];

  public selectedOffreAlimentaireList: number[] = [];
  public selectedRepasList: number[] = [];
  public selectedRegimeList: number[] = [];
  public selectedPointFacturationList: number[] = [];
  public selectedPointLivraisonList: number[] = [];
  public selectedPrestationList: number[] = [];

  // endregion

  private virtualIndex: number = 0;

  constructor(private facturationClientSvc: FacturationClientService,
              private utilsSvc: UtilsService) {
  }

  private initHierarchy() {
    this.subHierarchy = this.facturationClientSvc.findLigneParametrageHierarchy().subscribe(result => {
      if (result) {
        this.hierarchy = result.one;
      }
    });
  }

  ngOnInit(): void {
    this.initHierarchy();
    this.openAddingArea();
    this.closeAddingArea();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subHierarchy);
    this.utilsSvc.unsubscribe(this.subToAdd);
  }

  openAddingArea() {
    this.facturationClientSvc.openAddingAreaLigneParametrage$.subscribe(() => {
      this.isAddAreaCollapsed = false;
    })
  }

  closeAddingArea() {
    this.facturationClientSvc.closeAddingAreaLigneParametrage$.subscribe(() => {
      this.isAddAreaCollapsed = true;
    })
  }

  addLignesParametrage() {
    let properties: ParametersGenerationLignesParametrage = {
      offreAlimentaireIds: [...this.selectedOffreAlimentaireList],
      prestationIds: [...this.selectedPrestationList],
      repasIds: [...this.selectedRepasList],
      regimeIds: [...this.selectedRegimeList],
      pointFacturationIds: [...this.selectedPointFacturationList],
      pointLivraisonIds: [...this.selectedPointLivraisonList],
      typeFactureClient: this.selectedTypeFactureClient
    }

    this.subToAdd = this.facturationClientSvc.prepareLignesParametrageToAdd(properties).subscribe(result => {
      if (result && !result.inError) {
        if (result.resultList?.length > 0) {
          result.resultList.forEach(line => {
            if (!line.id)
              line.id = --this.virtualIndex;
          })

          this.onNewLigneParametrage.emit(result.resultList)
        }
      }
    });

  }

  onTabChange = ($event: any) => {
    switch ($event.itemIndex) {
      case AddZoneTab.OFFRE_ALIMENTAIRE:
        this.offreAlimentaireList = this.hierarchy.offresAlimentaire;
        this.updateValueOffreAlimentaire([], AddZoneProperty.OFFRE_ALIMENTAIRE);
        break;
      case AddZoneTab.CLIENT:
        this.pointFacturationList = this.hierarchy.pointsFacturation;
        this.updateValueClient([], AddZoneProperty.POINT_FACTURATION);
        break;
    }
  }

  /**
   * Permet de mettre à jour la valeur et de réinitialiser les propriétés suivantes
   */
  updateValueClient = (value: number[], property: AddZoneProperty) => {
    switch (property) {
      case AddZoneProperty.POINT_FACTURATION:
        this.selectedPointFacturationList = value;
        this.pointLivraisonList = this.initProperty(this.selectedPointFacturationList, this.hierarchy.pointsLivraisonByPointFacturationId);
        value = [];
      // pas de break
      case AddZoneProperty.POINT_LIVRAISON:
        this.selectedPointLivraisonList = value;
        this.offreAlimentaireList = this.initProperty(this.selectedPointLivraisonList, this.hierarchy.offresAlimentaireByPointLivraison);
        value = [];
      // pas de break
      case AddZoneProperty.OFFRE_ALIMENTAIRE:
        this.selectedOffreAlimentaireList = value;
        this.prestationList = this.initProperty(this.selectedOffreAlimentaireList, this.hierarchy.prestationsByOffreAlimentaireId);
        value = [];
      // Pas de break
      case AddZoneProperty.PRESTATION:
        this.selectedPrestationList = value;
        this.repasList = this.initProperty(this.selectedPrestationList, this.hierarchy.repasByPrestationId);
        this.regimeList = this.initProperty(this.selectedPrestationList, this.hierarchy.regimesByPrestationId);
        this.selectedRegimeList = [];
        value = [];
      // Pas de break
      case AddZoneProperty.REPAS:
        this.selectedRepasList = value;
        break;
      case AddZoneProperty.REGIME:
        this.selectedRegimeList = value;
        break;
    }
  }

  /**
   * Permet de mettre à jour la valeur et de réinitialiser les propriétés suivantes
   */
  updateValueOffreAlimentaire = (value: number[], property: AddZoneProperty) => {
    switch (property) {
      case AddZoneProperty.OFFRE_ALIMENTAIRE:
        this.selectedOffreAlimentaireList = value;
        this.prestationList = this.initProperty(this.selectedOffreAlimentaireList, this.hierarchy.prestationsByOffreAlimentaireId);
        value = [];
      // Pas de break
      case AddZoneProperty.PRESTATION:
        this.selectedPrestationList = value;
        this.selectedRepasList = [];
        this.selectedRegimeList = [];

        this.repasList = this.initProperty(this.selectedPrestationList, this.hierarchy.repasByPrestationId);
        this.regimeList = this.initProperty(this.selectedPrestationList, this.hierarchy.regimesByPrestationId);
        this.pointFacturationList = this.initProperty(this.selectedPrestationList, this.hierarchy.pointsFacturationByPrestationId);

        value = [];
      // pas de break
      case AddZoneProperty.POINT_FACTURATION:
        this.selectedPointFacturationList = value;
        this.pointLivraisonList = this.initProperty(this.selectedPointFacturationList, this.hierarchy.pointsLivraisonByPointFacturationId);
        value = [];
      // pas de break
      case AddZoneProperty.POINT_LIVRAISON:
        this.selectedPointLivraisonList = value;
        break;
      case AddZoneProperty.REPAS:
        this.selectedRepasList = value;
        break;
      case AddZoneProperty.REGIME:
        this.selectedRegimeList = value;
        break;
    }
  }

  private initProperty(selected: number[], source: Map<number, NamedItem[]>) {
    let properties: NamedItem[] = [];

    if (selected?.length > 0) {
      let propertyLists: NamedItem[][] = [];
      selected.forEach(element => {
        propertyLists.push(source[element]);
      });

      let propertyIds: number[] = [];

      (propertyLists as any).flatMap(i => i).forEach(item => {
        if (!propertyIds.includes(item.id)) {
          properties.push(item);
          propertyIds.push(item.id);
        }
      });
    }

    return properties;
  }

  isParentSelected(selectedList: number[]) {
    return selectedList?.length > 0;
  }

  isReadyToAdd() {
    return this.selectedOffreAlimentaireList?.length > 0
      && this.selectedPrestationList?.length > 0
      && this.selectedRepasList?.length > 0
      && this.selectedRegimeList?.length > 0
      && this.selectedPointFacturationList?.length > 0
      && this.selectedPointLivraisonList?.length > 0;
  }

  reduceAddArea() {
    this.facturationClientSvc.announceCloseAddingAreaLigneParametrage();
    this.isAddAreaCollapsed = true;
  }

}

export enum AddZoneProperty {
  OFFRE_ALIMENTAIRE,
  PRESTATION,
  REPAS,
  REGIME,
  POINT_FACTURATION,
  POINT_LIVRAISON
}

export enum AddZoneTab {
  OFFRE_ALIMENTAIRE,
  CLIENT
}
